
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormProvider as Form } from 'react-hook-form';
import './FormProvider.css'; // Import your CSS file

export default function FormProvider({ children, onSubmit, methods, disabled }) {
  const isAllowedInDisabledMode = (target) =>
    target instanceof Element && Boolean(target.closest('.doNotDisable'));


  const isScrollOnlyElement = (target) => target.closest('.scrollOnly') !== null;

  const handleSubmit = disabled
    ? (event) => {
      event.preventDefault();
    }
    : onSubmit;

  const handleFocusCapture = (event) => {
    if (!disabled || isAllowedInDisabledMode(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.target instanceof HTMLElement) {
      event.target.blur();
    }
  };

  const handleKeyDownCapture = (event) => {
    if (!disabled || isAllowedInDisabledMode(event.target)) return;
    if (isScrollOnlyElement(event.target)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  };

  const handleClickCapture = (event) => {
    if (!disabled) return;
    if (isScrollOnlyElement(event.target)) {
      // Block clicks (add/remove chips, open dropdown)
      event.preventDefault();
      event.stopPropagation();
    }
  };

  useEffect(() => {
    document.body.style.overflowX = 'hidden'; // Disable horizontal scrolling
    document.body.style.overflowY = 'auto'; // Allow vertical scrolling
    document.documentElement.style.overflowX = 'hidden'; // Disable horizontal scrolling
    document.documentElement.style.overflowY = 'auto'; // Allow vertical scrolling

    return () => {
      document.body.style.overflowX = 'auto'; // Reset horizontal overflow on unmount
      document.body.style.overflowY = 'auto'; // Reset vertical overflow on unmount
      document.documentElement.style.overflowX = 'auto'; // Reset horizontal overflow on unmount
      document.documentElement.style.overflowY = 'auto'; // Reset vertical overflow on unmount
    };
  }, []);

  return (
    <Form {...methods}>
      <form
        onSubmit={handleSubmit}
        className={disabled ? 'form-provider-disabled' : ''}
        onFocusCapture={handleFocusCapture}
        onKeyDownCapture={handleKeyDownCapture}
        onClickCapture={handleClickCapture}
      >
        {children}
      </form>
    </Form>
  );
}

FormProvider.propTypes = {
  children: PropTypes.node,
  methods: PropTypes.object,
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool,
};
